import { computed, effect, inject, Injectable } from '@angular/core';
import { OrderApiResponseStateService } from './order-api-response-state.service';
import { BasePdResponseService } from './base-pd-response.service';
import { AdditionalOfferData, OfferType } from '../../../../../models/order/workflow/additional-offer.model';
import { OrderFlowType } from '../../../../../models/order/order.model';
@Injectable({ providedIn: 'root' })
export class WirelessProductResponseService extends BasePdResponseService {
    private orderApiResponseStateService = inject(OrderApiResponseStateService);
    productResponse = computed(() => this.orderApiResponseStateService.wirelessProductDetailsData());
    private readonly ABP_CHOICE_CODE = 'ATT-WIRELESS-ABP-BOTH-YES';
    private readonly PAPERLESS_BILLING_CHOICE_CODE = 'ATT-WIRELESS-ABP-PAPERLESS-YES';
    private readonly ABP_CUSTOMIZATION_CODE = 'ATT-WIRELESS-ABP-PAPERLESS-REQ';

    getProductComponent() {
        const pdResponse = this.productResponse();
        return pdResponse?.Components?.Component.find(c => c.ProductType === 'WIRELESS');
    }

    constructor() {
        super();
        effect(() => {
            const pdResponse = this.productResponse();
            if (pdResponse) {
                this.setupCustomizations();
            } else {
                this.customizations.set([]);
            }
        });
    }

    override setupCustomizations() {
        const pdCustomizations = this.getProductComponent();
        const customizations = this.flattenCustomizations(pdCustomizations, OrderFlowType.Wireless);
        this.customizations.set(customizations);
    }

    getABPAdditionalOfferData(abpEnabled: boolean): AdditionalOfferData {
        const abpChoiceCode = abpEnabled ? this.ABP_CHOICE_CODE : this.PAPERLESS_BILLING_CHOICE_CODE;
        return {
            choiceCode: abpChoiceCode,
            customizationCode: this.ABP_CUSTOMIZATION_CODE,
            type: OfferType.Required,
            usoc: abpChoiceCode,
        }
    }

    findChoiceByCode(choiceCode: string) {
        const found = this.customizations().filter(cust => cust.customization.Choices.Choice.some(choice => choice.ChoiceCode === choiceCode));
        if (found.length) {
            const cust = found[0].customization;
            const choice = cust.Choices.Choice.find(choice => choice.ChoiceCode === choiceCode);
            return { customization: cust, choice: choice! };
        }
        return null;
    }
}